export const FxgjkglRouter = [{
  path: '/fxgjkgl',
  component: () => import('./views/index')
}, {
  path: '/fxgjkgl/teams',
  component: () => import('./views/teams')
},
  {
    path: '/fxgjkgl/intro',
    component: () => import('./views/intro.vue')
  },
  {
    path: '/fxgjkgl/followup',// 健康随访
    component: () => import('./views/followup')
  },

  {
    path: '/fxgjkgl/paper',// 健康随访问卷
    component: () => import('./views/paper')
  },
  {
    path: '/fxgjkgl/result',// 健康随访问卷得分
    component: () => import('./views/result.vue')
  },
]



// WEBPACK FOOTER //
// ./src/page/fxgjkgl/router.js